import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
